import React from "react";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import "./style.scss";

function Pparkir() {
  useDocumentTitle("Pajak Parkir- BAPENDA BEKASI");
  return (
    <div className="page">
      <Header active="Pparkir" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Jenis Pelayanan / Pajak Parkir" />
          <div className="page-title-wrapper">
            <div className="page-title">PBJT ATAS JASA PARKIR</div>
          </div>

          {/* <p className="page-text">
         </p> */}

          <p className="subpage-title"><strong>PBJT Atas Jasa Parkir</strong></p>
          <p className="page-text">Jasa Parkir adalah jasa penyediaan atau penyelenggaraan tempat parkir di
luar badan jalan dan/atau pelayanan memarkirkan kendaraan untuk
ditempatkan di area parkir, baik yang disediakan berkaitan dengan pokok
usaha maupun yang disediakan sebagai suatu usaha, termasuk
penyediaan tempat penitipan Kendaraan Bermotor. Jasa Parkir termasuk dalam jenis Pajak Barang dan Jasa Tertentu yang selanjutnya disingkat PBJT adalah Pajak yang dibayarkan oleh konsumen akhir atas konsumsi barang dan/atau jasa tertentu. Barang dan Jasa Tertentu adalah barang dan jasa tertentu yang dijual
dan/atau diserahkan kepada konsumen akhir.
</p>
<p className="page-text"><strong>
Jasa Parkir meliputi: </strong><br></br>
a. penyediaan atau penyelenggaraan tempat parkir; dan/atau<br></br>
b. pelayanan memarkirkan kendaraan (parkir valet).
Tarif Pajak Parkir ditetapkan sebagai berikut :
<p></p>


<br></br>
<p className="page-text"><strong>
Dasar pengenaan PBJT adalah jumlah yang dibayarkan oleh konsumen
barang atau jasa tertentu, meliputi:</strong> <br></br>
a. Jumlah pembayaran kepada penyedia atau penyelenggara tempat parkir
dan/atau penyedia layanan memarkirkan kendaraan untuk PBJT atas
Jasa Parkir; <br></br>
b. Dalam hal pembayaran menggunakan voucer atau bentuk lain yang sejenis yang memuat nilai rupiah atau mata
uang lain, dasar pengenaan PBJT ditetapkan sebesar nilai rupiah atau
mata uang lainnya tersebut;<br></br>
c. Dalam hal tidak terdapat pembayaran, dasar pengenaan PBJT dihitung berdasarkan harga jual barang dan
jasa sejenis yang berlaku di wilayah Daerah.<br></br>
d. Dalam hal Pemerintah Daerah menetapkan kebijakan pengendalian
penggunaan kendaraan pribadi dan tingkat kemacetan, khusus untuk
PBJT atas Jasa Parkir, Pemerintah Daerah dapat menetapkan dasar
pengenaan sebesar tarif parkir sebelum dikenakan potongan
<p></p>


<br></br>
<strong>Tarif PBJT atas Jasa Parkir ditetapkan sebesar 10% (sepuluh persen)</strong>
</p>

<br></br>
<p className="page-text"><strong>
DASAR HUKUM : </strong><br></br>
<a href="https://jdih.bekasikota.go.id/peraturan-daerah/view?id=525" target="_blank" rel="noreferrer"><font color="blue">Peraturan Daerah Kota Bekasi Nomor 1 Tahun 2024 Tentang Pajak Daerah Dan Retribusi Daerah</font></a>
</p>


</p>		
        
         
         
          
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default Pparkir;
